import React from 'react';
import classNames from 'classnames';
import { captureEvent } from '../../../../utils/gaUtil';
var getBannerForSize = function (banner, size) {
    if (size === void 0) { size = 'desktop'; }
    if (!banner || !banner[size]) {
        return {};
    }
    return banner[size] || {};
};
var BannerAd = function (_a) {
    var banners = _a.banners, page = _a.page, size = _a.size;
    var _b = getBannerForSize(banners, size), src = _b.src, link = _b.link;
    if (!src) {
        return null;
    }
    var handleBannerClick = function () {
        captureEvent('campaign', page, link !== null && link !== void 0 ? link : '<No link for banner>');
    };
    return React.createElement("div", { className: classNames('banner', size) },
        React.createElement("a", { href: link, target: "_blank", onClick: handleBannerClick },
            React.createElement("img", { src: src, alt: "Reklame" })));
};
export default BannerAd;
